import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import SquadMate from './squad-mate-model'
import {
  CreateSquadMateAsync,
  DeleteSquadMateAsync,
  LoadSquadMatesAsync,
} from './squadMate-thunk'
const initialState: squadMateSliceState = {
  squadMate: [],
  selected_squadMate: '',
  is_loading_squadMate: false,
  is_creating_squadMate: false,
  is_deleting_squadMate: false,
}
export interface squadMateSliceState {
  squadMate: SquadMate[]
  selected_squadMate?: string
  is_loading_squadMate: boolean
  is_creating_squadMate: boolean
  is_deleting_squadMate: boolean
}
export const squadMateSlice = createSlice({
  name: 'squadMate',
  initialState,
  reducers: {
    setSelectedsquadMate: (state, action) => {
      state.selected_squadMate = action.payload
    },
    clearStatesquadMate: (state) => {
      state.squadMate = []
      state.is_loading_squadMate = false
      state.is_creating_squadMate = false
      state.is_deleting_squadMate = false
    },
    mergesquadMate: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_squadMate = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.squadMate = merge(state.squadMate, payload) as any
        }
      }
    },

    add_squadMate: (state, action) => {
      if (action.payload) {
        state.squadMate = [...state.squadMate, action.payload]
      }
    },
    set_squadMate: (state, action) => {
      let { key, value, id } = action.payload
      state.squadMate = state.squadMate.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSquadMatesAsync.pending, (state) => {
      state.is_loading_squadMate = true
    })
    builder.addCase(LoadSquadMatesAsync.fulfilled, (state, action) => {
      state.is_loading_squadMate = false
      if (action.payload) {
        state.squadMate = action.payload
      }
    })
    builder.addCase(LoadSquadMatesAsync.rejected, (state) => {
      state.is_loading_squadMate = false
    })
    builder.addCase(CreateSquadMateAsync.pending, (state) => {
      state.is_creating_squadMate = true
    })
    builder.addCase(CreateSquadMateAsync.fulfilled, (state) => {
      state.is_creating_squadMate = false
    })
    builder.addCase(CreateSquadMateAsync.rejected, (state) => {
      state.is_creating_squadMate = false
    })
    builder.addCase(DeleteSquadMateAsync.pending, (state) => {
      state.is_deleting_squadMate = true
    })
    builder.addCase(DeleteSquadMateAsync.fulfilled, (state, action) => {
      state.is_deleting_squadMate = false
      if (state.squadMate) {
        state.squadMate = state.squadMate.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSquadMateAsync.rejected, (state) => {
      state.is_deleting_squadMate = false
    })
  },
})

export const {
  clearStatesquadMate,
  setSelectedsquadMate,
  set_squadMate,
  mergesquadMate,
  add_squadMate,
} = squadMateSlice.actions

export const get_squadMate =
  (id?: string) =>
  (state: {
    squadMate: {
      squadMate: SquadMate[]
    }
  }): SquadMate | null => {
    let temp = state?.squadMate?.squadMate?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.squadMate?.squadMate[0] || null
  }
export const get_selected_squadMate = (state: {
  squadMate: squadMateSliceState
}): SquadMate | null => {
  let id = state?.squadMate?.selected_squadMate
  let temp = state?.squadMate?.squadMate?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_squadMate = (state: {
  squadMate: {
    squadMate: SquadMate[]
  }
}): SquadMate[] => {
  let temp = state?.squadMate?.squadMate
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_squadMate_busy = (state: {
  squadMate: squadMateSliceState
}) => {
  return (
    state?.squadMate.is_deleting_squadMate ||
    state?.squadMate.is_loading_squadMate ||
    state?.squadMate.is_creating_squadMate
  )
}
export const is_deleting_squadMate_busy = (state: {
  squadMate: squadMateSliceState
}) => {
  return state?.squadMate.is_deleting_squadMate
}
export const is_loading_squadMate_busy = (state: {
  squadMate: squadMateSliceState
}) => {
  return state?.squadMate.is_loading_squadMate
}
export const is_creating_squadMate_busy = (state: {
  squadMate: squadMateSliceState
}) => {
  return state?.squadMate.is_creating_squadMate
}

export default squadMateSlice.reducer
